import { Controller } from "@hotwired/stimulus"

// Prevents email scraping by assembling the email address via JavaScript
// Bots that scrape HTML won't find the email - it's only constructed client-side
//
// Usage:
// <a href="#" data-controller="obfuscate-email"
//    data-obfuscate-email-user-value="support"
//    data-obfuscate-email-domain-value="getpoolflow.com">
//   Contact Support
// </a>

export default class extends Controller {
  static values = {
    user: String,
    domain: String
  }

  connect() {
    const email = `${this.userValue}@${this.domainValue}`
    this.element.href = `mailto:${email}`

    // If the link text is a placeholder, replace with the email
    if (this.element.dataset.showEmail === "true") {
      this.element.textContent = email
    }
  }
}
